import coverImg from "assets/images/v154/bg.webp"
import pictureImg from "assets/images/v154/cover.webp"
import titleImg from "assets/images/v154/title.webp"

export const v154Config = {
  cover: { en: coverImg },
  title: { en: titleImg },
  picture: pictureImg,
}
